{
  "name": "expo-app",
  "main": "expo-router/entry",
  "version": "1.79.0",
  "scripts": {
    "build": "expo export --platform web --source-maps && bun run sentry:sourcemaps",
    "dev": "expo start --web",
    "start": "expo start",
    "android": "DARK_MODE=media expo start --android",
    "ios": "DARK_MODE=media expo start --ios",
    "web": "DARK_MODE=media expo start --web",
    "test": "jest --watchAll",
    "lint": "expo lint",
    "typecheck": "tsc --noEmit",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:headed": "playwright test --headed",
    "e2e:debug": "playwright test --headed --timeout=0",
    "e2e:report": "playwright show-report",
    "sentry:sourcemaps": "VERSION=$(node -p \"require('./package.json').version\") && sentry-cli sourcemaps inject --org loopedin-13 --project web-app --release expo-app@$VERSION dist && sentry-cli sourcemaps upload --org loopedin-13 --project web-app --release expo-app@$VERSION dist"
  },
  "jest": {
    "preset": "jest-expo",
    "moduleNameMapper": {
      "^use-styled$": "<rootDir>/../../node_modules/use-styled/dist/index.js"
    },
    "transformIgnorePatterns": [
      "/node_modules/(?!((jest-)?react-native|@react-native(-community)?)|expo(nent)?|@expo(nent)?/.*|@expo-google-fonts/.*|react-navigation|@react-navigation/.*|@sentry/react-native|native-base|react-native-svg|use-styled|clsx|tailwind-merge)",
      "/node_modules/react-native-reanimated/plugin/"
    ]
  },
  "expo": {
    "doctor": {
      "reactNativeDirectoryCheck": {
        "listUnknownPackages": false
      }
    }
  },
  "dependencies": {
    "@convex-dev/react-query": "^0.0.0-alpha.11",
    "@expo-google-fonts/geologica": "^0.4.1",
    "@expo-google-fonts/zilla-slab": "^0.4.0",
    "@expo/html-elements": "^0.4.2",
    "@expo/vector-icons": "^14.1.0",
    "@gorhom/bottom-sheet": "^5.1.6",
    "@hookform/resolvers": "^5.1.1",
    "@intercom/messenger-js-sdk": "^0.0.18",
    "@legendapp/motion": "^2.4.0",
    "@netless/fastboard": "^1.1.0",
    "@netless/window-manager": "^1.0.6",
    "@react-native-async-storage/async-storage": "2.1.2",
    "@react-navigation/bottom-tabs": "^7.2.0",
    "@react-navigation/native": "^7.0.14",
    "@sentry/cli": "^2",
    "@sentry/react": "^10.38.0",
    "@stripe/react-stripe-js": "^5.3.0",
    "@stripe/stripe-js": "^8.2.0",
    "@tanstack/react-query": "^5.83.0",
    "@uiw/react-markdown-editor": "^6.1.4",
    "agora-rtc-sdk-ng": "^4.24.0",
    "babel-plugin-module-resolver": "^5.0.2",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "expo": "^53.0.19",
    "expo-auth-session": "^6.2.1",
    "expo-av": "^15.1.7",
    "expo-blur": "~14.1.5",
    "expo-constants": "~17.1.7",
    "expo-dev-client": "~5.2.4",
    "expo-document-picker": "~13.1.6",
    "expo-font": "~13.3.2",
    "expo-image-picker": "~16.1.4",
    "expo-linking": "~7.1.7",
    "expo-localization": "~16.1.6",
    "expo-router": "~5.1.3",
    "expo-splash-screen": "~0.30.10",
    "expo-status-bar": "~2.2.3",
    "expo-symbols": "~0.4.5",
    "expo-system-ui": "~5.0.10",
    "expo-web-browser": "~14.2.0",
    "google-libphonenumber": "^3.2.42",
    "nativewind": "^4.1.23",
    "posthog-js": "^1.279.0",
    "react": "19.0.0",
    "react-dom": "19.0.0",
    "react-hook-form": "^7.61.1",
    "react-native": "0.79.5",
    "react-native-calendars": "^1.1313.0",
    "react-native-css-interop": "^0.1.22",
    "react-native-gesture-handler": "~2.24.0",
    "react-native-markdown-display": "^7.0.2",
    "react-native-modal": "^14.0.0-rc.1",
    "react-native-reanimated": "~3.17.4",
    "react-native-safe-area-context": "5.4.0",
    "react-native-screens": "~4.11.1",
    "react-native-svg": "15.11.2",
    "react-native-toast-message": "^2.3.3",
    "react-native-web": "^0.20.0",
    "react-native-webview": "13.13.5",
    "react-native-worklets": "^0.6.1",
    "tailwindcss": "^3.4.17",
    "use-debounce": "^10.0.5",
    "use-styled": "^1.1.2"
  },
  "devDependencies": {
    "@babel/core": "^7.25.2",
    "@playwright/test": "^1.57.0",
    "@testing-library/react-native": "^13.3.3",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/jest": "^29.5.12",
    "@types/react": "19.0.0",
    "@types/react-test-renderer": "19.0.0",
    "eslint": "^9.0.0",
    "eslint-config-expo": "~9.2.0",
    "jest": "^29.2.1",
    "jest-expo": "~53.0.9",
    "jscodeshift": "^0.15.2",
    "react-test-renderer": "19.0.0",
    "typescript": "^5.5.4"
  },
  "private": true
}
